import { useQuery } from '@tanstack/react-query';
import { getUserId } from 'features/customer/store/selectors';
import { httpGetWorkspaceMembersOfCustomer } from 'services/backofficeIntegration/http/endpoints/workspace/httpGetWorkspaceMembersOfCustomer';
import { useAppSelector } from 'store/hooks';
import { queryClient } from 'utils/ReactQueryClient';

export const useGetAllCustomerWorkspaceIds = () => {
  const workspaceId = useAppSelector(state => state.workspace.workspaceId);
  const customerId = useAppSelector(getUserId);

  return useQuery({
    enabled: !!workspaceId && !!customerId,
    queryKey: ['customer-workspace-ids', workspaceId, customerId],
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error('workspaceId is required');
      }

      const workspaceMembers = await httpGetWorkspaceMembersOfCustomer.callEndpoint({
        customerId,
      });
      return workspaceMembers.map(workspaceMember => workspaceMember.workspaceId);
    },
  });
};

export const invalidateGetAllCustomerWorkspaceIdsQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: ['customer-workspace-ids'],
  });
};
